/* eslint-disable no-useless-escape */
import axios from 'axios'

import apiUrls from '../../constants/api'
// import router from '../../router'

import moment from 'moment'
import localeFormat from '../../constants/dateFormat'

const dateFormat = (date, locale) => {
  const formatDate = localeFormat.dateFormat(locale)
  const formatTime = localeFormat.timeFormat(locale)
  return moment(String(date)).format(formatDate + ' ' + formatTime)
}

let withCredentials = { withCredentials: true }
if (process.env.VUE_APP_ENV === 'develop' || process.env.VUE_APP_ENV === 'local') {
  withCredentials = ''
}

// const axiosConfig = {
//   headers: { 'X-Requested-With': 'XMLHttpRequest' },
//   withCredentials: true
// }

const dataStateToQuery = (dataState, state) => {
  const query = []
  const exportQuery = []
  const defaultState = {
    action: {
      currentPage: 1
    },
    skip: 0,
    take: 10,
    isPrimary: true,
    isTransactional: false,
    type: 'all'
  }
  const currentState = dataState || defaultState
  const { action, take, sorted, where, isPrimary, isTransactional, type } = currentState

  if (currentState) {
    const page = action.currentPage || 1
    const pageSize = take || 10
    query.push(`page=${page}`)
    query.push(`pagesize=${pageSize}`)

    if (isPrimary !== undefined || isTransactional !== undefined || type !== undefined) {
      // If issalescampaign flag is true setting the issalesemail dynamic query to 1
      if (state.b2bCampaignType === 'Sales') {
        query.push('issubproject.eq=0')
        query.push('issalesemail.eq=1')
      } else {
        query.push(`issubproject.eq=${!isPrimary ? 1 : 0}`)
        query.push('issalesemail.eq=0')
      }
      query.push(`istransactional.eq=${!isTransactional ? 0 : 1}`)
      query.push(`statefilter.eq=${type || 'all'}`)
    }

    if (sorted) {
      const sort = sorted[0]
      const column = sort.name
      const direction = sort.direction === 'descending' ? 'desc' : 'asc'
      query.push(`sortby=${direction}(${column.toLowerCase()})`)
      exportQuery.push(`sortby=${direction}(${column.toLowerCase()})`)
    }
    if (where) {
      const operations = {
        startswith: 'stw',
        endswith: 'edw',
        contains: 'cts',
        equals: 'eq',
        notequal: 'neq',
        greaterthan: 'gt',
        greaterthanorequal: 'gte',
        lessthan: 'lt',
        lessthanorequal: 'lte'
      }
      const statuses = {
        Valid: 1,
        Invalid: 4,
        Null: 2,
        Unsubscribed: 5,
        Bounced: 6,
        'Non-Consent': 8,
        Flagged: 7
      }
      // .NET year format is yyyy instead of YYYY, and day format is dd instead of DD
      const dateFormat = state.dateFormat.replace(/Y/g, 'y').replace(/D/g, 'd')

      where[0].predicates.forEach(predicate => {
        const operator = operations[predicate.operator] || 'eq'
        if (predicate.field) {
          switch (predicate.field) {
            case 'emailStatus':
              query.push(`status.cts=${statuses[predicate.value]}`)
              exportQuery.push(`status.cts=${statuses[predicate.value]}`)
              break
            case 'statusCampaignTranslated':
              query.push(`status.cts=${predicate.value}`)
              exportQuery.push(`status.cts=${predicate.value}`)
              break
            case 'updateDate':
              query.push(`updatedate|updatedby[${dateFormat} ${state.timeFormat}].${operator}=${predicate.value}`)
              break
            default:
              query.push(`${predicate.field.toLowerCase()}.${operator}=${predicate.value}`)
              exportQuery.push(`${predicate.field.toLowerCase()}.${operator}=${predicate.value}`)
          }
        } else if (predicate.predicates) { // Email Status
          const emailStatuses = predicate.predicates.map(pred => pred.field === 'statusCampaignTranslated' ? pred.value : statuses[pred.value]).join(',')
          query.push(`status.cts=${emailStatuses}`)
          exportQuery.push(`status.cts=${emailStatuses}`)
        }
      })
    }
  } else {
    query.push('page=1')
    query.push('pagesize=10')
  }

  const dynamicQuery = query.join('&')
  const dynamicExportQuery = exportQuery.length ? (exportQuery.join('&')) : ''
  const queries = { dynamicQuery, dynamicExportQuery }
  return queries
}

const dataStateToQueryMessaging = (dataState, state) => {
  const query = []
  const exportQuery = []
  const defaultState = {
    action: {
      currentPage: 1
    },
    take: 10,
    type: 'all'
  }
  const currentState = dataState || defaultState
  const { action, take, sorted, where } = currentState

  if (currentState) {
    const page = action.currentPage || 1
    const pageSize = take || 10
    query.push(`page=${page}`)
    query.push(`pagesize=${pageSize}`)

    if (sorted) {
      const messagingGridNames = {
        projectId: 'campaignId',
        campaignId: 'campaignId',
        title: 'campaignName',
        campaignName: 'campaignName',
        channel: 'channel',
        statusCampaignTranslated: 'status',
        status: 'status',
        audienceName: 'audienceName',
        updateDate: 'updateDate'
      }

      const sort = sorted[0]
      const column = messagingGridNames[sort.name]
      const direction = sort.direction === 'descending' ? 'desc' : 'asc'
      query.push(`sortby=${direction}(${column.toLowerCase()})`)
      exportQuery.push(`sortby=${direction}(${column.toLowerCase()})`)
    }
    if (where) {
      const operations = {
        startswith: 'stw',
        endswith: 'edw',
        contains: 'cts',
        equals: 'eq',
        notequal: 'neq',
        greaterthan: 'gt',
        greaterthanorequal: 'gte',
        lessthan: 'lt',
        lessthanorequal: 'lte'
      }
      const statuses = {
        Valid: 1,
        Invalid: 4,
        Null: 2,
        Unsubscribed: 5,
        Bounced: 6,
        'Non-Consent': 8,
        Flagged: 7
      }
      // .NET year format is yyyy instead of YYYY, and day format is dd instead of DD
      const dateFormat = state.dateFormat.replace(/Y/g, 'y').replace(/D/g, 'd')

      where[0].predicates.forEach(predicate => {
        const operator = operations[predicate.operator] || 'eq'
        if (predicate.field) {
          switch (predicate.field) {
            case 'projectId':
              query.push(`campaignId.cts=${predicate.value}`)
              exportQuery.push(`campaignId.cts=${predicate.value}`)
              break
            case 'title':
              query.push(`campaignName.cts=${predicate.value}`)
              exportQuery.push(`campaignName.cts=${predicate.value}`)
              break
            case 'emailStatus':
              query.push(`status.cts=${statuses[predicate.value]}`)
              exportQuery.push(`status.cts=${statuses[predicate.value]}`)
              break
            case 'status':
              query.push(`status.cts=${predicate.value}`)
              exportQuery.push(`status.cts=${predicate.value}`)
              break
            case 'channel':
              query.push(`channel.cts=${predicate.value}`)
              exportQuery.push(`channel.cts=${predicate.value}`)
              break
            case 'statusCampaignTranslated':
              query.push(`status.cts=${predicate.value}`)
              exportQuery.push(`status.cts=${predicate.value}`)
              break
            case 'updateDate':
              query.push(`updatedate|updatedby[${dateFormat} ${state.timeFormat}].${operator}=${predicate.value}`)
              break
            default:
              query.push(`${predicate.field.toLowerCase()}.${operator}=${predicate.value}`)
              exportQuery.push(`${predicate.field.toLowerCase()}.${operator}=${predicate.value}`)
          }
        } else if (predicate.predicates) { // messaging Status
          const emailStatuses = predicate.predicates.map(pred => pred.field === 'status' ? pred.value : pred.value).join(',')
          query.push(`status.cts=${emailStatuses}`)
          exportQuery.push(`status.cts=${emailStatuses}`)
        }
      })
    }
  } else {
    query.push('page=1')
    query.push('pagesize=10')
  }

  const dynamicQuery = query.join('&')
  const dynamicExportQuery = exportQuery.length ? (exportQuery.join('&')) : ''
  const queries = { dynamicQuery, dynamicExportQuery }
  return queries
}

export const actions = {
  setCampaignsByPage ({ commit, state }, { companyId, isPrimary, userEmail, dataState, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    const queries = dataStateToQuery(dataState, state)
    const dynamicQuery = queries.dynamicQuery
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getCampaignListByPage(state.clientId, companyId, userEmail, dynamicQuery), withCredentials)
        .then(response => {
          response.data.data.forEach(campaign => {
            if (campaign.updateDate !== 'Invalid date' && campaign.updateDate) {
              campaign.updateDate = dateFormat(campaign.updateDate, state.locale)
            }
            // Null audience are causing errors in the filter
            if (!campaign.audienceName) campaign.audienceName = ''
          })
          const dataResult = {
            result: response.data.data,
            count: response.data.page.totalRecords
          }
          commit('SET_CAMPAIGNS', dataResult)
          if (isPrimary) {
            commit('SET_PRIMARY_CAMPAIGNS', dataResult)
          } else {
            commit('SET_SUB_CAMPAIGNS', dataResult)
          }
          if (showLoading) {
            commit('SET_LOADING', false)
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
        })
    })
  },
  setCampaignAudienceCustomers ({ commit, state }, { parentCompanyId, projectId, userEmail, dataState }) {
    const queries = dataStateToQuery(dataState, state)
    const dynamicQuery = queries.dynamicQuery
    commit('SET_LOADING_CUSTOMERS', true)
    commit('SET_CAMPAIGN_AUDIENCE_DYNAMICQUERY', queries.dynamicExportQuery)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getCampaignAudienceCustomers(parentCompanyId, projectId, userEmail, dynamicQuery), withCredentials)
        .then(response => {
          resolve(response)
          const dataResult = {
            result: response.data.data.customerList,
            count: response.data.data.total
          }
          commit('SET_LOADING_CUSTOMERS', false)
          commit('SET_CAMPAIGN_AUDIENCE_CUSTOMERS', dataResult)
        })
        .catch(error => {
          reject(error)
          console.log(error)
          commit('SET_LOADING_CUSTOMERS', false)
        })
    })
  },
  setMessagingCampaignsByPage ({ commit, state }, { companyId, campaignStatus, channel, userEmail, dataState, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }

    const queries = dataStateToQueryMessaging(dataState, state)
    const dynamicQuery = queries.dynamicQuery
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getMessagingCampaignListByPage(state.clientId, companyId, campaignStatus, channel, userEmail, dynamicQuery), withCredentials)
        .then(response => {
          // Checking that data is not null if it is, no records found
          if (response.data.data != null) {
            response.data.data.forEach(campaign => {
              if (campaign.updateDate !== 'Invalid date' && campaign.updateDate) {
                campaign.updateDate = dateFormat(campaign.updateDate, state.locale)
              }
              // Null audience are causing errors in the filter
              if (!campaign.audienceName) campaign.audienceName = ''
            })
          } else {
            // If data is null setting as empty array to handle data correctly
            response.data.data = []
          }
          const dataResult = {
            result: response.data.data,
            count: response.data.page.totalRecords
          }
          commit('SET_LOADING', false)
          commit('SET_MESSAGING_CAMPAIGNS', dataResult)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
        })
    })
  },
  setMessagingCampaignsCountsByState ({ commit, state }, { companyId, channel, userEmail }) {
    axios.get(apiUrls.manageCampaign.getMessagingCampaignCountsByState(state.clientId, companyId, channel, userEmail), withCredentials)
      .then(response => {
        commit('SET_MESSAGING_CAMPAIGNS_COUNTS', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setCampaignsCountsByState ({ commit, state }, { companyId, isPrimary, isTransactional, userEmail, sales }) {
    axios.get(apiUrls.manageCampaign.getCampaignCountsByState(state.clientId, companyId, isPrimary, isTransactional, userEmail, sales), withCredentials)
      .then(response => {
        commit('SET_CAMPAIGNS_COUNTS', response.data)
        console.log(state.clientId, companyId, isPrimary, isTransactional, userEmail, sales)
        console.log('test responsedata', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setMessageCampaign ({ commit, state }, { companyId, campaignId, userEmail, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.getMessagingCampaign(messagingBaseURL, companyId, campaignId, userEmail),
        method: 'get',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          // Formatting the response to include campaignId & channelType keys
          // Doing this to show campaign details summary page data
          const campaign = response.data
          campaign.campaignId = campaignId
          campaign.channelType = response.data.channels[0].type
          campaign.phoneNumber = response.data.channels[0].from
          campaign.messagePreview = response.data.channels[0].template
          commit('SET_MESSAGE_SUMMARY', campaign)
          commit('SET_LOADING', false)
          resolve({
            success: campaign
          })
        })
        .catch(err => {
          console.log(err)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
          reject(err)
        })
    })
  },
  setMessageAudience ({ commit, state }, { companyId, audienceId, campaignType, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.getMessagingAudience(messagingBaseURL, companyId, audienceId, campaignType),
        method: 'get',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          commit('SET_MESSAGE_AUDIENCE', response.data.audience)
          commit('SET_LOADING', false)
          resolve({
            success: response
          })
        })
        .catch(err => {
          console.log(err)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
          reject(err)
        })
    })
  },
  fetchMessageAudienceTooltip ({ commit, state }, { companyId, audienceId, campaignType, showLoading = true }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.getMessagingAudience(messagingBaseURL, companyId, audienceId, campaignType),
        method: 'get',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          resolve({
            success: response
          })
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  setMessageHistory ({ commit, state }, { companyId, campaignId, userEmail, DynamicQuery, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    // Checking if dynamicQuery is passed from action dispatch
    // Summary wont dispatch dynamic query and default to 5
    // History tab will dispatch dynamic query to get full history list
    const dynamicQueryApplied = DynamicQuery === undefined ? '' : DynamicQuery
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.getMessagingHistory(messagingBaseURL, companyId, campaignId, dynamicQueryApplied),
        method: 'get',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          commit('SET_MESSAGE_HISTORY', response.data.items)
          commit('SET_LOADING', false)
          resolve({
            success: response
          })
        })
        .catch(err => {
          console.log(err)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
          reject(err)
        })
    })
  },
  setMessageStatistics ({ commit, state }, { companyId, campaignId, userEmail, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.getMessageStatistics(messagingBaseURL, companyId, campaignId, userEmail),
        method: 'get',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          commit('SET_MESSAGE_STATISTICS', response.data.statistics)
          commit('SET_LOADING', false)
          resolve({
            success: response
          })
        })
        .catch(err => {
          console.log(err)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
          reject(err)
        })
    })
  },
  async fetchAudienceCriteria ({ commit, state }, { audienceId, userEmail }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getAudienceCriteria(state.clientId, audienceId, userEmail), withCredentials)
        .then(response => {
          // This call is for Audience Preview Criteria
          window.DYNAMIC_CRITERIA_DATA = response.data
          commit('SET_LOADING', false)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
          commit('SET_LOADING', false)
          reject(error)
        })
    })
  },
  setCampaignSummary ({ commit, state }, { projectId, userEmail, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    axios.get(apiUrls.manageCampaign.getCampaignSummary(state.clientId, projectId, userEmail), withCredentials)
      .then(response => {
        commit('SET_CAMPAIGN_SUMMARY', response.data)
        if (showLoading) {
          commit('SET_LOADING', false)
        }
      })
      .catch(error => {
        console.log(error)
        if (showLoading) {
          commit('SET_LOADING', false)
        }
      })
  },
  setCampaignHistory ({ commit, state }, { projectId, userEmail, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    axios.get(apiUrls.manageCampaign.getCampaignHistory(state.clientId, projectId, userEmail), withCredentials)
      .then(response => {
        commit('SET_CAMPAIGN_HISTORY', response.data)
        if (showLoading) {
          commit('SET_LOADING', false)
        }
      })
      .catch(error => {
        console.log(error)
        if (showLoading) {
          commit('SET_LOADING', false)
        }
      })
  },
  setCampaignAudience ({ commit, state }, { parentCompanyId, projectId, userEmail }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.manageCampaign.getCampaignAudience(parentCompanyId, projectId, userEmail), withCredentials)
      .then(response => {
        commit('SET_CAMPAIGN_AUDIENCE', response.data.data)
        commit('SET_CAMPAIGN_COUNT_GENERATING', response.data.data.generatingCountsForecast)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  setCountGenerating ({ commit }, { parentCompanyId, projectId, userEmail }) {
    axios.get(apiUrls.manageCampaign.getCampaignAudience(parentCompanyId, projectId, userEmail), withCredentials)
      .then(response => {
        console.log(response.data.data.generatingCountsForecast)
        commit('SET_CAMPAIGN_COUNT_GENERATING', response.data.data.generatingCountsForecast)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setCampaignAudienceFilters ({ commit, state }, { parentCompanyId, projectId, userEmail }) {
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getCampaignAudienceFilters(parentCompanyId, projectId, userEmail), withCredentials)
        .then(response => {
          commit('SET_CAMPAIGN_AUDIENCE_FILTERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  setCampaignAudienceSummary ({ commit, state }, { parentCompanyId, projectId, userEmail }) {
    axios.get(apiUrls.manageCampaign.getAudienceSummary(parentCompanyId, projectId, userEmail), withCredentials)
      .then(response => {
        commit('SET_AUDIENCE_SUMMARY', response.data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setMessagingAudienceSummary ({ commit, state }, { parentCompanyId, audienceId, userEmail }) {
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getMessagingAudienceSummary(parentCompanyId, audienceId, userEmail), withCredentials)
        .then(response => {
          const summaryResponse = response.data.data
          if (summaryResponse != null) {
            summaryResponse.audienceId = audienceId
          }
          commit('SET_MESSAGING_AUDIENCE_SUMMARY', summaryResponse)
          resolve(summaryResponse)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  setCampaignConvertToAudience ({ commit, state }, { projectId, audienceName, userEmail }) {
    commit('SET_LOADING', true)
    // const headers = { headers: { 'x-api-user': userEmail } }
    return new Promise((resolve, reject) => {
      // let payload = { projectId, audienceName }
      // payload = JSON.stringify(payload)
      axios.get(apiUrls.manageCampaign.postConvertToAudience(state.clientId, state.userEmail, projectId, audienceName, state.einsightUri.replace(/^(https?):\/\//, '')), withCredentials)
        .then(response => {
          resolve(response)
          commit('SET_LOADING', false)
        }, error => {
          // console.log(error)
          reject(error)
          commit('SET_LOADING', false)
        })
    })
  },
  setCampaignContent ({ commit, state }, { parentCompanyId, projectId, userEmail }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getProjectTemplateContent(parentCompanyId, projectId, userEmail), withCredentials)
        .then(response => {
          resolve(response)
          commit('SET_CAMPAIGN_CONTENT', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          reject(error)
          commit('SET_LOADING', false)
        })
    })
  },
  cancelSchedule ({ commit, state }, { projectId }) {
    commit('SET_LOADING', true)
    axios.get(state.einsightUri + apiUrls.manageCampaign.cancelSchedule(projectId), withCredentials)
      .then(response => {
        console.log(response)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  setCampaignReport ({ commit, state }, { projectId }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.manageCampaign.getCampaignReport(state.clientId, projectId, state.userEmail), withCredentials)
      .then(response => {
        commit('SET_CAMPAIGN_REPORT', response.data.reverse())
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  setCampaignBasicValidation ({ commit, state }, { projectId }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.manageCampaign.getBasicValidation(state.clientId, projectId, state.userEmail), withCredentials, withCredentials)
      .then(response => {
        const data = response.data
        commit('SET_BASIC_VALIDATION', data)
        commit('SET_VALIDATION_CAMPAIGN_ID', projectId)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  setCampaignInboxPreviewAndForecaster ({ commit, state }, { projectId }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.manageCampaign.getInboxPreviewAndForecaster(state.clientId, projectId, state.userEmail), withCredentials)
      .then(response => {
        commit('SET_CAMPAIGN_INBOX_PREVIEW_AND_FORECASTER', response.data)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  requestCampaignInboxPreview ({ commit, state }, { projectId }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.requestInboxPreview(state.clientId, projectId, state.userEmail), withCredentials)
        .then(response => {
          commit('SET_LOADING', false)
          resolve(response)
        }, error => {
          reject(error)
          commit('SET_LOADING', false)
        })
    })
  },
  requestCampaignInboxForecaster ({ commit, state }, { projectId }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.requestInboxForecaster(state.clientId, projectId, state.userEmail), withCredentials)
        .then(response => {
          commit('SET_LOADING', false)
          resolve(response)
        }, error => {
          reject(error)
          commit('SET_LOADING', false)
        })
    })
  },
  requestApproval ({ commit }, { parentCompanyId, projectId, userEmail }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.requestApproval(parentCompanyId, projectId, userEmail), withCredentials)
        .then(response => {
          resolve(response)
          commit('SET_LOADING', false)
        }, error => {
          reject(error)
          commit('SET_LOADING', false)
        })
    })
  },
  setLocale ({ commit }, { email }) {
    axios.get(apiUrls.user.getLocale(email), withCredentials)
      .then(response => {
        const locale = response.data.data ?? 'en-US'
        commit('SET_LOCALE', locale)
        const dateFormat = localeFormat.dateFormat(locale)
        const timeFormat = localeFormat.timeFormat(locale)
        commit('SET_DATE_FORMAT', dateFormat)
        commit('SET_TIME_FORMAT', timeFormat)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setParentCompanySetting ({ commit, state }, { settings, email }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.user.getParentCompanySettings(state.companyId, settings, email), withCredentials)
      .then(response => {
        commit('SET_LOADING', false)
        if (settings === 'TimeZoneFeatureEnabled') {
          commit('SET_TIMEZONE_FEATURE', response.data.data)
        } else {
          commit('SET_CAMPAIGN_JOURNEY', response.data.data)
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  // setMessagingCompanySetting ({ commit, state }, { clientId, email }) {
  //   commit('SET_LOADING', true)
  //   axios.get(apiUrls.user.getMessagingCompanySettings(clientId, email), withCredentials)
  //     .then(response => {
  //       if ('SMSMessaging' in response.data && response.data.SMSMessaging === 'Y') {
  //         commit('SET_SMS_MESSAGING', true)
  //       }
  //       if ('WhatsAppMessaging' in response.data && response.data.WhatsAppMessaging === 'Y') {
  //         commit('SET_WHATSAPP_MESSAGING', true)
  //       }
  //       commit('SET_LOADING', false)
  //     })
  //     .catch(error => {
  //       console.log(error)
  //       commit('SET_LOADING', false)
  //     })
  // },
  setSalesCompanySetting ({ commit, state }, { clientId, email }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.user.getSalesCompanySettings(clientId, email), withCredentials)
      .then(response => {
        commit('SET_HAS_SALES', response.data)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  setCompanySetting ({ commit, state }, { settings, email }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.user.getCompanySettings(state.companyId, settings, email), withCredentials)
      .then(response => {
        if (settings === 'TransactionalMailingInTestMode') {
          commit('SET_TRANSACTIONAL_TEST_MODE', response.data.data)
        } else if (settings === 'HasEmailContentApproval') {
          commit('SET_HAS_EMAIL_CONTENT_APPROVAL', response.data.data)
        } else if (settings === 'IsInboxForecasterEnabled') {
          commit('SET_IS_INBOX_FORECASTER_ENABLED', response.data.data)
        }
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  deleteCampaign ({ commit, state }, { projectId, userEmail, clientId, companyId }) {
    commit('SET_LOADING', true)
    axios.get(apiUrls.manageCampaign.deleteCampaign(clientId, projectId, userEmail), withCredentials)
      .then(response => {
        commit('DELETE_CAMPAIGN', projectId)
        // router.push({ name: 'Campaigns', query: { clientId, companyId, userEmail: btoa(userEmail) } }, () => {
        //   // router.go(0)
        //   commit('SET_LOADING', false)
        // })
        // axios.post(apiUrls.templateBuilder.deleteChildTemplatesByExternalId(state.accountId, projectId, userEmail), withCredentials)
        // commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
      })
  },
  approveCampaign ({ commit, state }, { projectId, userEmail, showLoading = true }) {
    if (showLoading) {
      commit('SET_LOADING', true)
    }
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.approveCampaign(state.clientId, projectId, userEmail), withCredentials)
        .then(response => {
          resolve(response)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
        })
        .catch(error => {
          reject(error)
          if (showLoading) {
            commit('SET_LOADING', false)
          }
        })
    })
  },
  rejectCampaign ({ commit, state }, { projectId, reason, userEmail }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.rejectCampaign(state.clientId, projectId, reason, userEmail), withCredentials)
        .then(response => {
          resolve(response)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          reject(error)
          commit('SET_LOADING', false)
        })
    })
  },
  activateschedule ({ commit, state }, { projectId, activate, userEmail }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.activateSchedule(state.clientId, projectId, activate, userEmail), withCredentials)
        .then(response => {
          resolve(response)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          reject(error)
          commit('SET_LOADING', false)
        })
    })
  },
  setApproverPermission ({ commit, state }) {
    const oktaToken = state.oktaToken
    const companyId = state.companyId
    const messagingBaseURL = state.messagingBaseUrl
    axios({
      url: apiUrls.messaging.getApprovalPermissionControl(messagingBaseURL, companyId),
      method: 'get',
      headers: {
        Authorization: `Bearer ${oktaToken}`
      }
    })
      .then(response => {
        const hasApproverPermission = response.data.permissions.map(({ permission }) => permission === 'Approver').includes(true)
        if (hasApproverPermission) {
          commit('SET_APPROVER_PERMISSION', hasApproverPermission)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  getMessagingCampaignHistory ({ commit, state }, { companyId, campaignId, dynamicQuery }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.getMessagingCampaignHistory(messagingBaseURL, companyId, campaignId, dynamicQuery),
        method: 'get',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.log(err)
        })
    })
  },
  getMessagingCampaignSchedule ({ commit, state }, { companyId, campaignId }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.getMessagingCampaignSchedule(messagingBaseURL, companyId, campaignId),
        method: 'get',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.log(err)
        })
    })
  },
  updateMessagingCampaignSchedule ({ commit, state }, { companyId, campaignId, schedule }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.updateMessagingCampaignSchedule(messagingBaseURL, companyId, campaignId),
        method: 'put',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        },
        data: schedule
      })
        .then(response => {
          console.log('approveMessagingCampaign', response)
          commit('SET_LOADING', false)
          resolve(response)
        })
        .catch(err => {
          console.log(err)
          commit('SET_LOADING', false)
          reject(err)
        })
    })
  },
  approveMessagingCampaign ({ commit, state }, { companyId, campaignId }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.approveMessagingCampaign(messagingBaseURL, companyId, campaignId),
        method: 'put',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          console.log('approveMessagingCampaign', response)
          commit('SET_LOADING', false)
          resolve(response)
        })
        .catch(err => {
          console.log(err)
          commit('SET_LOADING', false)
          reject(err)
        })
    })
  },
  requestMessagingCampaign ({ commit, state }, { companyId, campaignId }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.requestMessagingCampaign(messagingBaseURL, companyId, campaignId),
        method: 'put',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        }
      })
        .then(response => {
          console.log('requestMessagingCampaign', response)
          commit('SET_LOADING', false)
          resolve(response)
        })
        .catch(err => {
          console.log(err)
          commit('SET_LOADING', false)
          reject(err)
        })
    })
  },
  rejectMessagingCampaign ({ commit, state }, { companyId, campaignId, rejectReason }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.rejectMessagingCampaign(messagingBaseURL, companyId, campaignId),
        method: 'put',
        headers: {
          Authorization: `Bearer ${oktaToken}`
        },
        data: rejectReason
      })
        .then(response => {
          console.log('rejectMessagingCampaign', response)
          commit('SET_LOADING', false)
          resolve(response)
        })
        .catch(err => {
          console.log(err)
          commit('SET_LOADING', false)
          reject(err)
        })
    })
  },
  messagingSendTest ({ commit, state }, { companyId, campaignId, validTestPhoneNumbers }) {
    const oktaToken = state.oktaToken
    const messagingBaseURL = state.messagingBaseUrl
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      axios({
        url: apiUrls.messaging.messagingSendTest(messagingBaseURL, companyId, campaignId),
        method: 'post',
        headers: {
          Authorization: `Bearer ${oktaToken}`,
          'Content-Type': 'application/json'
        },
        data: validTestPhoneNumbers
      })
        .then(response => {
          console.log('messagingSendTest', response)
          commit('SET_LOADING', false)
          resolve(response)
        })
        .catch(err => {
          console.log(err)
          commit('SET_LOADING', false)
          reject(err)
        })
    })
  },
  setUserAccessControl ({ commit }, { userEmail }) {
    axios.get(apiUrls.user.getUserAccessControl(userEmail), withCredentials)
      .then(response => {
        commit('SET_USER_ACCESS_CONTROL', response.data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  exportCustomers ({ commit, state }, { projectId, userEmail, dynamicQuery }) {
    const dataExportSettings = state.appConfig.dataExporterSettings
    const headers = { headers: { 'X-Api-Key': dataExportSettings.apikey } }
    return new Promise((resolve, reject) => {
      axios.get(dataExportSettings.uri + apiUrls.manageCampaign.exportCustomers(projectId, userEmail, dynamicQuery), headers)
        .then(response => {
          console.log(response)
          resolve(response)
        }, error => {
          console.log(error)
          reject(error)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  setAccountId ({ commit, state }, { userEmail }) {
    const externalId = state.companyId
    axios.get(apiUrls.templateBuilder.getAccountIdbyExternalId(externalId, userEmail), withCredentials)
      .then(response => {
        commit('SET_ACCOUNT_ID', response.data.id)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getChildTemplateByExternalId ({ commit, state }, { projectId, userEmail }) {
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.templateBuilder.getChildTemplateByExternalId(state.accountId, projectId, userEmail), withCredentials)
        .then(({ data, status, statusText }) => {
          if (status === 200) {
            if (Object.prototype.hasOwnProperty.call(data, 'id')) {
              resolve(data.id)
            } else {
              resolve(0)
            }
          } else if (status === 204) {
            resolve(0)
          } else {
            resolve(0)
          }
          // commit('SET_CURRENT_CHILD_TEMPLATE_ID', response.data.id)
        }).catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  convertToMaster ({ commit, state }, { childTemplateId, userEmail }) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrls.templateBuilder.convertToMaster(state.accountId, childTemplateId, userEmail), withCredentials)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  getCampaignTemplate ({ commit, state }, { projectId, userEmail }) {
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.manageCampaign.getCampaignTemplate(state.clientId, projectId, userEmail), withCredentials)
        .then(({ data, status, statusText }) => {
          if (status === 200) {
            resolve(data)
          } else {
            resolve({
              error: status,
              text: statusText
            })
          }
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  addTemplate ({ commit, state }, { userEmail, data }) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrls.templateBuilder.addTemplate(state.accountId, userEmail), data, withCredentials)
        .then(({ data, status, statusText }) => {
          if (status === 200) {
            resolve(data)
          } else {
            resolve({
              error: status,
              text: statusText
            })
          }
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  }
  // deleteTemplateChildresnByExternalId ({ commit, state }, { projectId, userEmail }) {
  //  return new Promise((resolve, reject) => {
  //    axios.post(apiUrls.templateBuilder.deleteChildTemplatesByExternalId(state.accountId, projectId, userEmail), withCredentials)
  //      .then(({ data, status, statusText }) => {
  //        if (status === 200) {
  //          resolve(data)
  //        } else {
  //          resolve({
  //            error: status,
  //            text: statusText
  //          })
  //        }
  //      })
  //      .catch(err => {
  //        console.log(err)
  //        reject(err)
  //      })
  //  })
  // }
}
